module.exports = __webpack_public_path__ + "img/1557614064720486401.80cf912e.png";